import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as SecurityDocActions from '../_actions/securityDoc';
import { SecurityDoc } from '../_models/securityDoc';

export interface SecurityDocState extends EntityState<SecurityDoc> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<SecurityDoc> = createEntityAdapter<SecurityDoc>();

const initialState: SecurityDocState = adapter.getInitialState({
  loading: false,
  error: null,
});

const securityDocReducer = createReducer(
  initialState,

  on(SecurityDocActions.loadSecurityDocs, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(SecurityDocActions.loadSecurityDocsSuccess, (state, { securityDocs }) =>
    adapter.setAll(securityDocs, { ...state, loading: false })
  ),

  on(SecurityDocActions.loadSecurityDocsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(SecurityDocActions.addSecurityDocSuccess, (state, { securityDoc }) =>
    adapter.addOne(securityDoc, state)
  ),

  on(SecurityDocActions.updateSecurityDocSuccess, (state, { securityDoc }) =>
    adapter.upsertOne(securityDoc, state)
  ),

  on(SecurityDocActions.deleteSecurityDocSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    SecurityDocActions.addSecurityDocFailure,
    SecurityDocActions.updateSecurityDocFailure,
    SecurityDocActions.deleteSecurityDocFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: SecurityDocState | undefined, action: Action) {
  return securityDocReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
